import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';

export const accessTokenInterceptor: HttpInterceptorFn = (req, next) => {
    const oauth = inject(OAuthService);
    const token = oauth.getAccessToken();

    if (token) {
        req = req.clone({
            setHeaders: { Authorization: `Bearer ${token}` }
        });
    }

    return next(req);
};
